<template>
  <div class="flex flex-wrap justify-around">
    <button class="pbc-component-link-or-transform-button" v-for='link in recommendations' :key='link.name' @click='select(link)'>
      <div class="flex justify-left p-1">
        <div class="pbc-component-link-or-transform-buton--icon pbc-add-component-type-icon-parent">
          <link-variant class="pbc-add-component-type-icon" :size='32'/>
        </div>
        <div class="pbc-component-link-or-transform-button--title">
          {{link.title}}
        </div>
      </div>
      <div v-if='link.description' class="pbc-component-link-or-transform-button--description">
        {{link.description}}
      </div>
      <div v-else class="pbc-component-link-or-transform-button--description">
        Create when condition is met.
      </div>
    </button>
  </div>
</template>
<script>
import LinkVariant from '@icons/LinkVariant.vue';
import { sample } from 'lodash';
import IconMapping from '@components/iconMapping.js';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
export default {
  props: {
    recommendations: {
      type: Array,
      required: true
    }
  },
  components:{
    LinkVariant
  },
  methods:{
    select(link) {
      this.$emit("select", link);
    }
  },
  computed: {
    myRecommendations() {
      return this.recommendations.map( ({recommendation}) => {
        const componentTypes = recommendation.components.map( (component) => {
          console.log('cccccc', component);
          const type = ComponentsDb.types[component.type];
          const icon = IconMapping[type.type];
          return {
            type,
            icon
          }
        });

        const headingType = componentTypes[0].type;
        return {headingType, componentTypes,...recommendation}

      });
    },
  }
}
</script>
